import API_CONSTANT from 'constants/apiConstant';
import { get, post } from 'utils/RequestV2';
import { post as postLoan } from 'utils/RequestLoan';

export const fetchEligibility = async () => get('v1/' + API_CONSTANT.URL.UNDERWRITING_ELIGIBLE);

export const handleUnderwritingRerun = async (payload) => post('v1/' + API_CONSTANT.URL.UNDERWRITING_RERUN, payload);

export const fetchLoanDetails = async (payload) => postLoan(API_CONSTANT.URL.DSA_LOANS.LOAN_DETAILS, payload);

export const createDsaLoan = async (payload) => postLoan(API_CONSTANT.URL.DSA_LOANS.CREATE_LOANS, payload);
